<template>
  <v-container v-show="visible">
    <v-row>
      <v-col cols="6">
        <v-row>
          <v-col cols="3">
            <v-text-field
                v-model="fioFilter"
                clearable
                label="ФИО сотрудника"
                @keydown.enter="getTeachers"
                @click:append-outer="getTeachers"
                @click:clear="getTeachers"
                @focusout="getTeachers"
            >
              <template v-slot:append-outer>
                <v-btn icon @click="getTeachers">
                  <v-icon color="primary">search</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <v-checkbox
                v-model="onlyTeachersFilter"
                label="Только преподаватели"
            />
          </v-col>
          <v-col cols="3">
            <v-checkbox
                v-model="notLinkedOrionFilter"
                label="Только непривязанные пропуска"
            />
          </v-col>
          <v-col cols="3">
            <v-checkbox
                v-model="notLinkedLMSFilter"
                label="Только непривязанные LMS"
            />
          </v-col>
        </v-row>
        <v-progress-linear :active="loading" :indeterminate="loading"/>
        <v-data-table
            :headers="headers"
            :items="studs"
            :pagination.sync="pagination"
            :items-per-page="pageSize"
            class="elevation-2"
            hide-default-footer
            loading-text="Загрузка сотрудников"
        >
          <template v-slot:body="{ items }">
            <tbody>
            <tr :class="backgroundColor(item) ? 'selected-row' : ''" v-for="(item) in items" :key="item.id">
              <td class="text-center v-data-table__divider">{{ item.teacher }}</td>
              <td class="text-center v-data-table__divider">
                <v-tooltip bottom v-if="item.codeLms != null && item.codeLms != ''" >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="success" v-on="on" v-bind="attrs">
                      check_circle_outline
                    </v-icon>
                  </template>
                  <span>Привязан</span>
                </v-tooltip>
                <v-tooltip bottom v-if="item.codeLms == null || item.codeLms == ''" >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="error" v-on="on" v-bind="attrs">
                      highlight_off
                    </v-icon>
                  </template>
                  <span>Не привязан</span>
                </v-tooltip>
              </td>
              <td class="text-center v-data-table__divider">
                <v-tooltip bottom v-if="item.orionId != null && item.orionId != ''" >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="success" v-on="on" v-bind="attrs">
                      check_circle_outline
                    </v-icon>
                  </template>
                  <span>Привязан</span>
                </v-tooltip>
                <v-tooltip bottom v-if="item.orionId == null || item.orionId == ''" >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="error" v-on="on" v-bind="attrs">
                      highlight_off
                    </v-icon>
                  </template>
                  <span>Не привязан</span>
                </v-tooltip>
              </td>
              <td class="text-center v-data-table__divider">
                <v-row>
                  <v-col cols="4">
                    <v-tooltip bottom v-if="item != currentSelectedTeacher">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            color="success"
                            @click="selectTeacherToLink(item)"
                            v-bind="attrs"
                            v-on="on"
                        >
                          <v-icon>link</v-icon>
                        </v-btn>
                      </template>
                      <span>Выбрать для связки</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="item == currentSelectedTeacher">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            color="white"
                            @click="resetTeacherToLink()"
                            v-bind="attrs"
                            v-on="on"
                        >
                          <v-icon>link</v-icon>
                        </v-btn>
                      </template>
                      <span>Отменить выбор</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="4">
                    <v-tooltip bottom v-if="item != currentSelectedTeacher && item.orionId != null">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            color="error"
                            v-bind="attrs"
                            v-on="on"
                            @click="openUnlinkDialog(item)"
                        >
                          <v-icon>credit_card</v-icon>
                        </v-btn>
                      </template>
                      <span>Отвязать пропуск</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="4">
                    <v-tooltip bottom v-if="item != currentSelectedTeacher && item.codeLms != null">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            color="error"
                            v-bind="attrs"
                            v-on="on"
                            @click="openUnlinkLmsDialog(item)"
                        >
                          <v-icon>person</v-icon>
                        </v-btn>
                      </template>
                      <span>Отвязать личный кабинет LMS</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </td>
            </tr>
            </tbody>
          </template>
        </v-data-table>
        <v-alert v-if="(studs == null || studs.length == 0) && !loading" :value="true" color="error" icon="warning">
          Сотрудники не найдены. Попробуйте изменить фильтры
        </v-alert>
        <!-- Пагинация -->
        <v-card-text>
          <v-row>
            <v-col
                cols="1"
                sm="1"
                md="1">
            </v-col>
            <v-col
                cols="2"
                sm="2"
                md="2">
              <v-select
                  v-model="pageSize"
                  :items="pageSizes"
                  label="Количество строк "
                  color="#36a2eb"
              >
              </v-select>
            </v-col>
            <v-col>
              <v-pagination
                  class="my-4"
                  v-model="pagination.page"
                  :length="pages"
                  total-visible="9"
                  circle
                  color="#36a2eb"
              >

              </v-pagination>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- Пагинация-->
      </v-col>
      <v-divider vertical/>
      <v-col cols="6">
        <v-container>
          <v-row>
            <v-switch
                v-model="switch1"
                inset
            >
              <template v-slot:prepend>
                <v-icon @click="switch1 = false" :color="switch1 ? 'gray' : 'primary'">person</v-icon>
              </template>
              <template v-slot:append>
                <v-icon @click="switch1 = true" :color="switch1 ? 'primary' : 'gray'">badge</v-icon>
              </template>
            </v-switch>
          </v-row>
          <v-row>
            <orion-cards-list ref="cardsList" :use-teachers="true" :disabled="!teacherSelected" v-show="switch1"/>
            <lms-user-list ref="lmsList" :use-teachers="true" :disabled="!teacherSelected" v-show="!switch1"/>
          </v-row>
        </v-container>
      </v-col>
    </v-row>

    <v-dialog v-if="selectedToUnlinkTeacher != null" v-model="unlinkDialog" max-width="800">
      <v-card>
        <v-toolbar
            dark
            color="primary"
        >
          <v-btn
              icon
              dark
              @click="closeUnlinkDialog()"
          >
            <v-icon>close</v-icon>
          </v-btn>
          <v-card-title>Вы уверены?</v-card-title>
        </v-toolbar>
        <v-card-title>
          Сотрудник "<strong>{{ selectedToUnlinkTeacher.teacher }}</strong>" будет отвязан
          от карты по ID "<strong>{{ selectedToUnlinkTeacher.orionId }}</strong>"!
        </v-card-title>
        <v-card-actions>
          <v-spacer/>
          <v-btn
              color="secondary"
              @click="closeUnlinkDialog"
              :disabled="unlinking"
          >
            Отменить
          </v-btn>
          <v-btn
              color="primary"
              @click="unlinkTeacher"
              :disabled="unlinking"
          >
            Отвязать
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="selectedToUnlinkTeacher != null" v-model="unlinkLmsDialog" max-width="800">
      <v-card>
        <v-toolbar
            dark
            color="primary"
        >
          <v-btn
              icon
              dark
              @click="closeUnlinkLmsDialog()"
          >
            <v-icon>close</v-icon>
          </v-btn>
          <v-card-title>Вы уверены?</v-card-title>
        </v-toolbar>
        <v-card-title>
          Сотрудник "<strong>{{ selectedToUnlinkTeacher.teacher }}</strong>" будет
          отвязан от личного кабинета LMS по ID: "<strong>{{ selectedToUnlinkTeacher.codeLms }}</strong>"!
        </v-card-title>
        <v-card-actions>
          <v-spacer/>
          <v-btn
              color="secondary"
              @click="closeUnlinkLmsDialog"
              :disabled="unlinking"
          >
            Отменить
          </v-btn>
          <v-btn
              color="primary"
              @click="unlinkLmsTeacher"
              :disabled="unlinking"
          >
            Отвязать
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import OrionCardsList from "@/components/admin/OrionLinking/OrionCardsList";
import {HTTP} from "@/settings/axios";
import Settings from "@/settings/settings_url";
import LmsUserList from "@/components/admin/LmsLinking/LmsUserList";

export default {
  name: "TeacherLinking",

  components: {
    LmsUserList,
    OrionCardsList,
  },

  data() {
    return {
      switch1: true,
      unlinkDialog: false,
      loading: false,
      fioFilter: null,
      notLinkedOrionFilter: false,
      notLinkedLMSFilter: false,
      onlyTeachersFilter: false,
      unlinkLmsDialog: false,
      studs: [],
      pages: 1,
      pageSizes: [5, 10, 15, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      totalItems: 0,
      pagination: {
        page: 1,
      },
      page: 1,
      pageSize: 10,
      headers: [
        {text: 'ФИО', align: 'center', sortable: true, value: 'teacher', divider: true, class: "bolt"},
        {text: 'Статус привязки ЛК LMS', align: 'center', sortable: true, value: 'isLmsLinked', divider: true, class: "bolt"},
        {text: 'Статус привязки карты', align: 'center', sortable: true, value: 'isOrionLinked', divider: true, class: "bolt"},
        {text: 'Действия', align: 'center', sortable: true, value: 'actions', divider: true, class: "bolt"},
      ],
      teacherSelected: false,
      currentSelectedTeacher: null,
      selectedToUnlinkTeacher: null,
      unlinking: false,
      url: '/teachers',
    }
  },
  methods: {
    unlinkTeacher() {
      this.unlinking = true
      this.selectedToUnlinkTeacher.orionId = null

      HTTP.post(Settings.API.URL_DEFAULT + this.url + "/update-orion-id", this.selectedToUnlinkTeacher)
          .then((response) => {
            this.selectedToUnlinkTeacher = response.data
          }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.unlinking = false
        this.closeUnlinkDialog()
      })
    },
    unlinkLmsTeacher() {
      this.unlinking = true
      this.selectedToUnlinkTeacher.codeLms = null

      HTTP.post(Settings.API.URL_DEFAULT + this.url + "/update-lms-id", this.selectedToUnlinkTeacher)
          .then((response) => {
            this.selectedToUnlinkTeacher = response.data
          }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.unlinking = false
        this.closeUnlinkLmsDialog()
      })
    },
    openUnlinkLmsDialog(item) {
      this.selectedToUnlinkTeacher = item
      this.unlinkLmsDialog = true
    },
    closeUnlinkLmsDialog() {
      this.selectedToUnlinkTeacher = null
      this.unlinkLmsDialog = false
    },
    openUnlinkDialog(item) {
      this.selectedToUnlinkTeacher = item
      this.unlinkDialog = true
    },
    closeUnlinkDialog() {
      this.selectedToUnlinkTeacher = null
      this.unlinkDialog = false
    },
    async getTeachers() {
      this.loading = true
      let url = ""

      if (this.fioFilter != null)
        url += "&fio=" + this.fioFilter

      if (this.notLinkedOrionFilter != null)
        url += "&notLinked=" + this.notLinkedOrionFilter

      await HTTP.get(Settings.API.URL_DEFAULT + this.url
          + "/paginated" + "?page="
          + this.pagination.page + "&size=" + this.pageSize
          + "&getNotLinked=" + this.notLinkedOrionFilter
          + "&getNotLinkedLms=" + this.notLinkedLMSFilter
          + "&onlyTeachers=" + this.onlyTeachersFilter
          + url)
          .then((response) => {
            console.log(response.data)
            this.studs = response.data.content
            this.totalItems = response.data.totalElements
            this.pages = response.data.totalPages
            if (this.pagination.page > this.pages)
              this.pagination.page = 1

          })
          .catch(() => {

          })
          .finally(() => {
            this.loading = false
          });
    },
    selectTeacherToLink(stud) {
      this.teacherSelected = true
      this.currentSelectedTeacher = stud
      this.$refs.cardsList.userToLink = stud

      let fio = stud.teacher.split(" ")
      this.$refs.cardsList.familyNameFilter = fio[0]
      this.$refs.cardsList.nameFilter = fio[1]
      if(fio.length > 2)
        this.$refs.cardsList.patronymicFilter = fio[2]
      this.$refs.cardsList.getOrionUsers()

      this.$refs.lmsList.userToLink = stud
      this.$refs.lmsList.familyNameFilter = fio[0]
      this.$refs.lmsList.nameFilter = fio[1]
      if(fio.length > 2)
        this.$refs.lmsList.patronymicFilter = fio[2]
      this.$refs.lmsList.getLmsUsers()
    },
    backgroundColor(item) {
      if (item === this.currentSelectedTeacher)
        return 'selected-row'
    },
    resetTeacherToLink() {
      this.teacherSelected = false
      this.currentSelectedTeacher = null
      this.$refs.cardsList.resetFilters()
      this.$refs.lmsList.resetFilters()
    },
  },
  created() {
    this.getTeachers()
  },
  watch: {
    'currentTeacherSelected'() {
      if (this.currentSelectedTeacher === null)
        this.$refs.cardsList.resetFilters()
    },
    'fioFilter'() {
      this.resetTeacherToLink()
    },
    'pagination.page'() {
      this.getTeachers()
    },
    'pageSize'() {
      this.getTeachers()
    },
    'notLinkedOrionFilter'() {
      this.resetTeacherToLink()
      this.getTeachers()
    },
    'notLinkedLMSFilter'() {
      this.resetTeacherToLink()
      this.getTeachers()
    },
    'onlyTeachersFilter'() {
      this.resetTeacherToLink()
      this.getTeachers()
    }
  },
  props: {
    visible: {
      default: true,
      type: Boolean,
    },
  },
}
</script>

<style scoped>
.selected-row {
  background-color: grey;
}

.selected-row:hover {
  background-color: grey !important;
}
</style>
